function cleanString(value) {
  if (typeof value !== 'string') return '';
  return value.trim();
}

function mergeSeo(base, override) {
  return {
    title: cleanString(override.title) || cleanString(base.title),
    keywords: cleanString(override.keywords) || cleanString(base.keywords),
    description: cleanString(override.description) || cleanString(base.description),
    robots: cleanString(override.robots) || cleanString(base.robots),
    canonical: cleanString(override.canonical) || cleanString(base.canonical),
    ogTitle: cleanString(override.ogTitle) || cleanString(base.ogTitle),
    ogDescription: cleanString(override.ogDescription) || cleanString(base.ogDescription),
  };
}

export function buildMetaInfo({
  seoRecord,
  fallbackTitle,
}) {
  const seo = mergeSeo(
    {
      title: fallbackTitle,
      keywords: '',
      description: '',
      robots: '',
      canonical: '',
      ogTitle: '',
      ogDescription: '',
    },
    seoRecord || {}
  );

  const meta = [];
  const link = [];

  if (seo.keywords) meta.push({ name: 'keywords', content: seo.keywords });
  if (seo.description) meta.push({ name: 'description', content: seo.description });
  if (seo.robots) meta.push({ name: 'robots', content: seo.robots });
  if (seo.ogTitle) meta.push({ property: 'og:title', content: seo.ogTitle });
  if (seo.ogDescription) meta.push({ property: 'og:description', content: seo.ogDescription });
  if (seo.canonical) link.push({ rel: 'canonical', href: seo.canonical });

  return {
    title: seo.title || fallbackTitle,
    meta,
    link,
  };
}

